export const getCssValue = (cssVarName: string): string =>
  getComputedStyle(document.documentElement).getPropertyValue(cssVarName);

export const getCssParsedValue = (cssVarName: string): number => parseFloat(getCssValue(cssVarName));

export const setCssValue = (cssVarName: string, cssVarValue: string): void => {
  document.documentElement.style.setProperty(cssVarName, cssVarValue);
};
